<template>
	<!-- Vue Material Checkbox -->
	<!-- https://vuematerial.io/components/checkbox -->
	<md-checkbox
		:value="!value"
		class="ui-checkbox"
		@change="$emit('input', !value)"
	>
		{{ label }}
		<md-tooltip v-if="tooltip">{{ tooltip }}</md-tooltip>
	</md-checkbox>
</template>

<script>
export default {
	name: "Checkbox",
	props: {
		label: {
			type: String,
			default: "",
			required: false
		},
		tooltip: {
			type: String,
			default: "",
			required: false
		},
		value: {
			type: Boolean,
			required: true
		}
	}
};
</script>
